import { useRef, useState } from "react";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Progress } from "../ui/progress";
import { api, formatApiErrorDetail } from "@/lib/api";

export const MediaUpload = ({ folder, onUploaded, accept = "image/*", testid, label = "Enviar arquivo" }) => {
  const input = useRef(null);
  const [progress, setProgress] = useState(null);

  const upload = async (file) => {
    if (!file) return;
    const data = new FormData();
    data.append("folder", folder);
    data.append("file", file);
    setProgress(0);
    try {
      const r = await api.post("/admin/media/upload", data, { onUploadProgress: (e) => e.total && setProgress(Math.round((e.loaded * 100) / e.total)) });
      onUploaded(r.data.url);
      toast.success("Arquivo enviado para o Bunny CDN");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    setProgress(null);
    input.current.value = "";
  };

  return (
    <div className="space-y-1">
      <input ref={input} type="file" accept={accept} className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid={`${testid}-input`} />
      <button type="button" disabled={progress !== null} onClick={() => input.current.click()} data-testid={testid}
        className="inline-flex items-center gap-2 text-xs px-3 py-2 border border-[#9B6179]/30 rounded-[2px] hover:bg-[#F7F0E8] transition-colors disabled:opacity-50">
        {progress !== null ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
        {progress !== null ? `Enviando… ${progress}%` : label}
      </button>
      {progress !== null && <Progress value={progress} className="h-1" />}
    </div>
  );
};
